var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Singapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24,4C12.954,4,4,12.954,4,24h40C44,12.954,35.046,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24H4c0,11.046,8.954,20,20,20S44,35.046,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M18.621,20.688C18.023,20.895,17.387,21,16.715,21C13.562,21,11,18.543,11,15.5s2.562-5.5,5.715-5.5 c0.672,0,1.309,0.105,1.906,0.313c-2.887,0.098-5.188,2.387-5.188,5.188S15.734,20.59,18.621,20.688z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M17.426,15.633l-0.777-0.574l-0.773,0.574l0.297-0.922l-0.777-0.57h0.961l0.293-0.926l0.297,0.926 h0.961l-0.777,0.57L17.426,15.633z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M23.52,15.633l-0.777-0.574l-0.773,0.574l0.297-0.922l-0.777-0.57h0.961l0.293-0.926l0.297,0.926 L24,14.137l-0.777,0.57L23.52,15.633z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M20.477,13.457l-0.777-0.574l-0.773,0.574l0.297-0.926l-0.777-0.566h0.961l0.293-0.926l0.297,0.926 h0.961l-0.781,0.566L20.477,13.457z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M18.566,19.113l-0.777-0.574l-0.773,0.574l0.297-0.922l-0.777-0.57h0.961l0.293-0.926l0.297,0.926 h0.961l-0.781,0.57L18.566,19.113z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M22.379,19.113l-0.777-0.574l-0.773,0.574l0.297-0.922l-0.777-0.57h0.961l0.293-0.926l0.297,0.926 h0.961l-0.781,0.57L22.379,19.113z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Singapore);
export default __webpack_public_path__ + "static/media/icons8-singapore.ff3d98f69edd93095e585e529dd1627d.svg";
export { ForwardRef as ReactComponent };